import { FeatureFlags } from 'typings'
import * as actionTypes from './actionTypes'

export const setFeatureFlags = (featureFlags: Partial<FeatureFlags>) => ({
  type: actionTypes.SET_FEATURE_FLAGS,
  payload: featureFlags,
})

export const setFeatureFlagsLoaded = () => ({
  type: actionTypes.SET_FEATURE_FLAGS_LOADED,
})
